import styled from 'styled-components';

import { flex } from '@/styles/minix';
import { colorGroup } from '@/styles/common';

export const ProjectWrap = styled.div`
	height: 100%;

	& .ant-popover.ant-popover-placement-top {
		border-radius: 4px;

		.ant-popover-arrow {
			display: none;
		}

		.ant-popover-title {
			padding-top: 0;
			height: 36px;
			font-size: 12px;
			color: ${colorGroup.textSlight};
			line-height: 36px;
		}

		.client-card {
			${flex('column', 'flex-start', 'flex-start')};

			.client-line {
				${flex('row', 'flex-start', 'center')};
				line-height: 30px;

				> .left-name {
					color: ${colorGroup.textNote};
				}

				> .right-content {
					color: ${colorGroup.textImportant};
				}
			}
		}
	}
`;

export const ContentTitleEleWrap = styled.div`
	${flex()}
`;
